import cx from 'classnames';
import React, { ChangeEvent, FC } from 'react';

import styles from './CustomSwitch.module.scss';

interface CustomSwitchProps {
	id: string;
	checked: boolean;
	disabled?: boolean;
	onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const CustomSwitch: FC<CustomSwitchProps> = ({ checked, disabled, onChange, id }) => {
	return (
		<>
			<input
				className={styles.switchCheckbox}
				id={id}
				type="checkbox"
				checked={checked}
				onChange={onChange ? onChange : () => {}}
			/>
			<label
				className={cx(styles.switchLabel, disabled && styles.switchLabel_disabled)}
				htmlFor={id}
			>
				<span className={styles.switchButton} />
			</label>
		</>
	);
};
